require('./dist/polyfill');



//////////////////
// WEBPACK FOOTER
// ../~/@formatjs/intl-pluralrules/polyfill.js
// module id = 1459
// module chunks = 121